export class SaveMultiQuoteNotificationsRequest {
    lastName: string;
    firstName: string;
    phone: string;
    mail: string;
    quotePlan: string;
    notificationNumber?: number; 
    organizerCode?: number; 
    organizerName: string;
    producerCode?: number;  
    producerName: string;
    sellerCode?: number;  
    sellerName: string;
    quotationNumber?: number;  
    quotationState: string;
    notificationState: string;
    statisticsCode?: number;  
    origin?: number; 
    notes: string;
    step: string;
    quotationDetail: string;
}